import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';
import * as dayjs from 'dayjs';
import { jsPDF } from "jspdf";

import autoTable from 'jspdf-autotable'; // eslint-disable-line


const PDFDialog = ({ columns, rows, filename }) => {
	const pdfDownload = e => {
		e.preventDefault()
		let doc = new jsPDF('landscape');
		let head = [columns.filter(c => !c.noprint).map(c => c.headerName)];
		let body = rows.map(r => {
			let res = []
			columns.forEach(c => {
				if (['ignition_off_timestamp', 'event_timestamp'].includes(c.field)) {
					res.push(dayjs(r[c.field]).format('HH:mm:ss  DD MMM YYYY'));
				} else {
					res.push(r[c.field]);
				}
			});
			return res;
		});
		setTimeout(() => {
			doc.autoTable({
				head: head,
				body: body
				// alternateRowStyles: {
				// 	fillColor: '#d3d3d3'
				// },
				// styles: {
				// 	fillColor: '#3f51b5'
				// },
			});
			doc.save(filename)
		}, 500);
	}


	return (
		<div style={{ paddingTop: '15px' }} >
			<Tooltip title="Generate PDF">
				<Button
					color="primary"
					variant="contained"
					onClick={pdfDownload}
				>
					PDF Export
				</Button>
			</Tooltip>
		</div >
	)
}

PDFDialog.propTypes = {
}

export default PDFDialog
